import { Component, OnDestroy, OnInit } from '@angular/core';
import { CollaborationService } from '../../services/collaboration.service';
import { NotificationSettingsComponent } from '../notification-settings/notification-settings.component';

@Component({
    selector: 'app-notification-settings-page',
    templateUrl: './notification-settings-page.component.html',
    styleUrl: './notification-settings-page.component.scss',
    imports: [NotificationSettingsComponent]
})
export class NotificationSettingsPageComponent implements OnInit, OnDestroy {
  userName: string = '';
  constructor(private collaborationService: CollaborationService) {
  }
  ngOnInit() {
    this.notificationSettings();
    this.userName = this.collaborationService.userEmail;
  }
  notificationSettings() {
    this.collaborationService.setShowOrHideSideNav('notificationDrawer', true);
  }
  ngOnDestroy(): void {
    this.collaborationService.setShowOrHideSideNav('notificationDrawer', false);
  }
}
